import sendToServer from './send-to-server';
import trackEvent from './track-event';
import QuestionFluff from './question-fluff';

const Answers = {
  init(quizFunctionality, keyTermFunctionality) {
    this.quizFunctionality = quizFunctionality;
    this.keyTermFunctionality = keyTermFunctionality;
    this.fluffFunctionality = QuestionFluff.init();

    $('.answer-shower').click(this.handleAnswerShowerClick.bind(this));

    $('.questions .answer').click(this.handleAnswerClick.bind(this));
    $('.confirm-selection').click(this.handleConfirmSelectionClick.bind(this));

    if ($('.question').data('pre-answered')) {
      trackEvent('Question', 're-view', $('.question').data('question-id'));
      this.onQuestionAlreadyAnswered();
    } else {
      trackEvent('Question', 'viewed', $('.question').data('question-id'));
    }

    const noFeedback = $('.question').data('no-feedback');
    const alreadyShowingFeedback = $('.answer.correct').length > 0;
    // Show no immediate feedback if either [we don't want to provide feedback at all]
    // or [we're not already in a state where we should be showing feedback]
    this.noFeedbackRightNow = noFeedback || !alreadyShowingFeedback;

    return this;
  },

  onQuestionAlreadyAnswered() {
    $('.answer').each((_index, element) => {
      let $answer = $(element);
      if ($answer.data('correct')) {
        $answer.addClass('correct');
      } else {
        $answer.addClass('incorrect');
      }
    });
    $('.explanation-area').show();

    $('.next-panel').show();
  },

  handleAnswerShowerClick() {
    $('.answer-content').show();
    $('.answer-shower').hide();
  },

  handleAnswerClick(event) {
    if ($('.question').data('pre-answered')) return;
    if (this.quizFunctionality.disableAnswerSelection) return;

    const $answer = $(event.target).closest('.answer');

    if (this.noFeedbackRightNow) {
      if ($answer.hasClass('selected')) {
        this.fluffFunctionality.markUnselected($answer, true);
      } else {
        if ($('.question').data('total-correct-answers') === $('.answer.selected').length) {
          const $first = $('.answer.selected').first();
          this.fluffFunctionality.markUnselected($first, false);
        }
        this.fluffFunctionality.markSelected($answer);
      }

      this.showConfirmSelectionPanelIfAppropriate();


    } else {

      // Do nothing if the answer is already visible
      if ($answer.hasClass('correct') || $answer.hasClass('incorrect')) return;

      // Otherwise get and display feedback
      $('.answer-content .loading').fadeIn();
      sendToServer('/api/v2/questions/' + $('.question').data('question-id') + '/answers_given',
                   { answer_ids: [$answer.data('answer-id')] },
                   this.handleAnswerSubmissionResponse.bind(this));
    }
  },

  showConfirmSelectionPanelIfAppropriate() {
    if ($('.question').data('total-correct-answers') === $('.answer.selected').length && !this.quizFunctionality.preventSubmission) {
      $('.early-escape').hide();
      $('.confirm-selection-panel').slideDown(()=> {
        $("html, body").animate({ scrollTop: $(document).height() - $(window).height() - 80 }, 300);
      });

    } else {
      $('.confirm-selection-panel').slideUp();
    }
  },

  handleAnswerSubmissionResponse(response) {
    const data = response.responseJSON;
    $('.answer-content .loading').hide();

    if (!data || response.status !== 201) return;
                       // Network connection error means we didn't contact the server successfully.
                       // Non-201 status means something else surprising went wrong, but at time of writing
                       // not enough is know about sources of this to do anything useful about it.
                       // Best we can do is nothing: User will hopefully assume misclick and try again.

    // Hide all incorrect explanation areas
    $('.answer.incorrect .explanation-area').hide();

    // Un-style incorrect answers
    $('.answer.incorrect').removeClass('incorrect');

    const completed = data.question_complete;

    $('.answer').each((_index, element) => {
      let $answer = $(element);
      data.answers_given.forEach((answerGiven)=>{
        if (answerGiven.id === $answer.data('answer-id')) {
          // Populate the chosen answers' explanation area and show it
          const $explanationArea = $answer.closest('.row').find('.explanation-area');

          $explanationArea.html(answerGiven.explanation).show();

          this.keyTermFunctionality.setupKeyTermsIn($explanationArea);

          if (answerGiven.value === 100) {
            // If the answer was correct, style it appropriately
            if (!completed) trackEvent('Question', 'correct answer given', $('.question').data('question-id'));
            this.fluffFunctionality.revealValue($answer, 'correct');

          } else if (answerGiven.value > 0) {
            if (!completed) {
              $('.question').data('aceable', false);
            }

            this.fluffFunctionality.revealValue($answer, 'acceptable');
          } else {
            if (!completed) {
              trackEvent('Question', 'incorrect answer given', $('.question').data('question-id'));
              // Track that we can no longer ace this question
              $('.question').data('aceable', false);
            }

            // Style the answer appropriately
            this.fluffFunctionality.revealValue($answer, 'incorrect');
          }
        }
      });
    });

    this.fluffFunctionality.playAppropriateAudio(data);

    if (completed) {
      $('.initial-instruction').hide();
      $('.try-again-instruction').hide();
      this.handleCompletion(data);
    } else {
      $('.initial-instruction').css('display', 'inline');
      $('.try-again-instruction').css('display', 'inline');
    }
  },

  handleConfirmSelectionClick() {
    $('.confirm-selection-panel').slideUp();
    let answerIds = [];

    $('.answer.selected').each((_index, element) => {
      let $answer = $(element);
      answerIds.push($answer.data('answer-id'));
    });

    const noFeedback = $('.question').data('no-feedback');

    if (!noFeedback) {
      this.noFeedbackRightNow = false;
      $('.answer-content .loading').fadeIn();
    }

    const onServerResponseWhenShowingFeedback = (response) => {
      $('.answer-content .loading').hide();
      this.quizFunctionality.onAnswerSubmission(this.handlePostSubmissionFeedback.bind(this, response));
    };

    sendToServer('/api/v2/questions/' + $('.question').data('question-id') + '/answers_given',
                 { answer_ids: answerIds, final_attempt: noFeedback },
                 (noFeedback ? null : onServerResponseWhenShowingFeedback));

    if (noFeedback) {
      // Show the emotion panel
      this.quizFunctionality.onAnswerSubmission(this.quizFunctionality.goToNextPath);
    }

  },

  handlePostSubmissionFeedback(response) {
    $('.answer').removeClass('selected');
    this.handleAnswerSubmissionResponse(response);
    if (response.responseJSON && response.responseJSON.question_complete) {
      $('.correct-explainer').show();
    } else if ($('.answer.correct').length > 0 || $('.answer.acceptable').length > 0) {
      $('.acceptable-explainer').show();
    } else {
      $('.incorrect-explainer').show();
    }
  },

  handleCompletion(data) {
    // If we've already run this function, never run it again
    if ($('.question').data('answered')) return;

    // If we didn't give any wrong answers, bump the star counter
    if ($('.question').data('aceable')) {
      $('.star-counter').removeClass('grey');
      $('.star-counter .number').html(parseInt($('.star-counter .number').html()) + 1);
      trackEvent('Question', 'aced', $('.question').data('question-id'));
    }

    trackEvent('Question', 'completed', $('.question').data('question-id'));
    $('.question').data('answered', true);

    this.fluffFunctionality.onRevealCompletion(()=>{
      $('.next-panel').slideDown(()=> {
        $("html, body").animate({ scrollTop: $(document).height()-$(window).height() }, 300);
      });
      this.notifyNewBadges(data.new_badges)
    });
  },

  notifyNewBadges(newBadges) {
    if (newBadges.length < 1) return;

    const template = $('.question-box').data('badge-notification');
    const $notificationArea = $('<div>', { class: 'new-badge-notification-area' });
    $('.question-box').append($notificationArea);

    newBadges.forEach((newBadge) => {
      const $notification = $('<div>', { class: 'new-badge-notification',
                                         text: template.replace('[LEVEL]', newBadge.level)
                                                       .replace('[SKILL]', newBadge.skill.name)});
      $notificationArea.append($notification);
    });

    window.setTimeout(()=>{ $notificationArea.fadeOut() }, 3000);
  }
};

export default Answers;
